<template>
	<v-container>
		<v-row>
			<v-col class="col-sm-4" cols="12">
				<v-text-field dense label="Rua" v-model="dados.residencial.rua" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-2" cols="12">
				<v-text-field dense label="Numero" v-model="dados.residencial.numero" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-3" cols="12">
				<v-text-field dense label="Compl" v-model="dados.residencial.complemento" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-3" cols="12">
				<v-text-field dense label="Bairro" v-model="dados.residencial.bairro" outlined></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="col-sm-3" cols="12">
				<v-text-field dense label="cidade" v-model="dados.residencial.cidade" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-2" cols="12">
				<v-text-field dense label="estado" v-model="dados.residencial.estado" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-3" cols="12">
				<v-select dense :items="this.listaPaises" v-model="dados.residencial.pais" label="País" outlined></v-select>
			</v-col>
			<v-col class="col-sm-4" cols="12">
				<v-text-field dense label="Cep" v-model="dados.residencial.cep" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-3" cols="12">
				<v-text-field dense label="Fone" v-model="dados.residencial.fone" outlined></v-text-field>
			</v-col>
			<v-col class="col-sm-3" cols="12">
				<v-text-field dense label="Celular" v-model="dados.residencial.celular" outlined></v-text-field>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import { mapState } from 'vuex'
//import Br from '@/config/barramento.js'
	export default{
		props:['dados'],
		computed:{
			...mapState(['listaPaises']),
		},
		data(){
			return{
				
			}
		},
		
		created(){

		}
	}
</script>
<style scoped>
	
</style>